import React from "react";
import { motion } from "framer-motion";
import AuroraWave from "../AuroraWave";

const PILLARS = [
  { n: "01", title: "Engineering Excellence", body: "Drawings first, tolerances stated, standards cited. We hold every product — from a light fixture to a software platform — to the discipline of an engineering document." },
  { n: "02", title: "Practical Innovation", body: "We innovate where it earns its keep. New technology enters our portfolio only when it solves a real industrial problem better than the alternative." },
  { n: "03", title: "Clear Commercial Boundaries", body: "DEBSUN delivers engineering and technology services and products. Large-scale EPC and turnkey execution is routed through our strategic engineering partner, SAI Enterprises — never blurred into a website quote." },
];

export default function WhyDebsun() {
  return (
    <section id="why" className="relative py-20 sm:py-28 lg:py-36 bg-secondary/40 border-y border-border overflow-hidden scroll-mt-[88px]" data-testid="why-debsun">
      <AuroraWave className="absolute left-0 right-0 bottom-0 h-[260px] w-[130%]" opacity={0.4} variant="thin" />
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 relative">
        <div className="mb-16">
          <div className="sec-index mb-4">04 — Principles</div>
          <h2 className="display display-section text-4xl md:text-6xl max-w-3xl">Why <span style={{ color: "var(--gold)" }}>DEBSUN</span>.</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border border border-border">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="bg-background p-8 sm:p-10 lg:p-12 group h-full"
              data-testid={`pillar-${i}`}
            >
              <div className="display text-6xl md:text-7xl text-transparent" style={{ WebkitTextStroke: "1px hsl(var(--hairline))" }}>{p.n}</div>
              <motion.div className="h-px mt-6 mb-7" initial={{ width: 0 }} whileInView={{ width: "48px" }} viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 + i * 0.12 }}
                style={{ background: "linear-gradient(90deg,var(--teal),var(--gold))" }} />
              <h3 className="display display-section text-2xl md:text-3xl">{p.title}</h3>
              <p className="mt-5 text-sm text-steel-text leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
